export class ScraperAPIService {
  static BASE_URL = '/.netlify/functions/extract-emails'

  static async extractEmails(url) {
    try {
      console.log('Extracting emails from:', url)

      const response = await fetch(`${this.BASE_URL}?url=${encodeURIComponent(url)}`, {
        method: 'GET',
        headers: {
          'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
        },
      })

      if (!response.ok) {
        throw new Error(`ScraperAPI error: ${response.status}`)
      }

      const html = await response.text()

      // Extract emails using the specified regex pattern
      const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g
      const matches = html.match(emailRegex) || []

      // Remove duplicates and limit to 3 emails
      const uniqueEmails = [...new Set(matches)]
        .filter(email => {
          // Filter out common non-contact emails
          const excludePatterns = [
            'noreply@', 'no-reply@', 'donotreply@', 'support@wordpress',
            'admin@wordpress', 'example@', 'test@', '@example.com',
            '@test.com', '@localhost', 'example@', '@example-domain.com', '@exampledomain.com', 'name@', 'firstname@', '@email.com', 'email@', '@domain.com'
          ]
          return !excludePatterns.some(pattern => email.toLowerCase().includes(pattern))
        })
        .slice(0, 3)

      console.log('Extracted emails:', uniqueEmails)
      return uniqueEmails
    } catch (error) {
      console.error('Error extracting emails:', error)
      throw error
    }
  }
}